// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"6d170173","51":"1033712e","208":"606daf4f","237":"39c8e112","638":"d526966b","852":"3ecf819e","983":"d627fc29"}[chunkId] + ".chunk.js";
};